export default __webpack_public_path__ + "static/media/29096-redberry.ce66075a.pdf";